import { Instance, types, getEnv, flow } from "mobx-state-tree";
import { reaction } from "mobx";

import { apiLastAccessedOrganization } from "../api/ApiLastAccessedOrganizationService";
import { appSessionStorage } from "../storage/SessionStorageService";
import { globalModule } from "../service-provider/GlobalModule";
import { StorageModel } from "../storage/StorageModel";
import { endpoints } from "../api/ApiEndpoints";
import { authentication } from "../authentication/Authentication";

export const OrganizationKey = "OrganizationId";

const LastAccessedOrganizationModel = types.model({});

export const LastAccessedOrganizationStorageModel = types
  .compose(LastAccessedOrganizationModel, StorageModel)
  .named("LastAccessedOrganizationStorageModel")
  .actions((self) => {
    return {
      mapResponse(response: any) {
        self.data = response;
        appSessionStorage.setStorageItem(OrganizationKey, self.data.organizationId);
      },
      updateLastAccessedOrganization: flow(function* (orgId: number) {
        yield getEnv(self).api.put(self.endpoint, orgId);
        yield self.load();
      }),
    };
  })
  .views((self) => ({
    get endpoint() {
      return endpoints.get("last_accessed_organization");
    },
    get canLoadItems() {
      // Never fetch for a guest (empty Bearer → 401 snackbar). Loads once authenticated,
      // driven by the reaction below. This is the root of the org/permissions chain.
      return !authentication.anonymous;
    },
  }));

export type LastAccessedOrganizationService = Instance<typeof LastAccessedOrganizationStorageModel>;
export const lastAccessedOrganizationService = LastAccessedOrganizationStorageModel.create(
  {},
  {
    api: apiLastAccessedOrganization,
    appSessionStorage: appSessionStorage,
  }
);

globalModule.lastAccessedOrganizationService = lastAccessedOrganizationService;

// Kick off the org/permissions chain the moment the user becomes authenticated (guest →
// signed in). afterCreate's autoLoad is a no-op while anonymous (canLoadItems=false).
reaction(
  () => authentication.anonymous,
  (anonymous) => {
    if (!anonymous) lastAccessedOrganizationService.load();
  }
);
